import React, { useCallback, useRef, useState } from 'react';

import { Wrapper } from './styles';

interface TiltCardProps {
  // Ângulo estático de base (a mesma inclinação que os mocks do mobile
  // já usavam antes de existir hover) -- some inteiramente com o mouse
  // sobre o card, sem esse resquício ele voltaria pra 0 no hover.
  baseRotateY?: number;
  baseRotate?: number;
  // Quanto o tilt reage ao mouse, em graus, além do ângulo de base.
  maxTilt?: number;
  className?: string;
}

const RESET_TRANSITION = 'transform 0.5s cubic-bezier(0.22, 0.7, 0.25, 1)';
const TRACK_TRANSITION = 'transform 0.1s ease-out';

// Tilt-card: a mesma inclinação estática 3D dos mocks do app mobile
// (perspective + rotateY/rotate fixos), agora também nos mocks do
// painel web, e mais pronunciada ao passar o mouse -- a inclinação
// segue a posição do cursor sobre o card em vez de só um hover fixo.
const TiltCard: React.FC<TiltCardProps> = ({
  baseRotateY = 0,
  baseRotate = 0,
  maxTilt = 10,
  className,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const baseTransform = `perspective(1200px) rotateY(${baseRotateY}deg) rotate(${baseRotate}deg)`;

  const [transform, setTransform] = useState(baseTransform);
  const [transition, setTransition] = useState(RESET_TRANSITION);

  const handleMouseMove = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      const rect = ref.current?.getBoundingClientRect();
      if (!rect) return;

      const px = (event.clientX - rect.left) / rect.width;
      const py = (event.clientY - rect.top) / rect.height;

      const rotateX = (0.5 - py) * maxTilt;
      const rotateY = baseRotateY + (px - 0.5) * maxTilt;

      setTransition(TRACK_TRANSITION);
      setTransform(
        `perspective(1200px) rotateX(${rotateX.toFixed(
          2,
        )}deg) rotateY(${rotateY.toFixed(
          2,
        )}deg) rotate(${baseRotate}deg) scale(1.03)`,
      );
    },
    [baseRotate, baseRotateY, maxTilt],
  );

  const handleMouseLeave = useCallback(() => {
    setTransition(RESET_TRANSITION);
    setTransform(baseTransform);
  }, [baseTransform]);

  return (
    <Wrapper
      ref={ref}
      className={className}
      style={{ transform, transition }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </Wrapper>
  );
};

export { TiltCard };
